export default __webpack_public_path__ + "static/media/cancelIcon.13d505c8.svg";